import React from 'react';

/** Sticky frame for the live rail. Beside the workbench (≥1080 px) it is capped to
 *  the window below the top bar, so the rail scrolls inside itself instead of
 *  being a sticky column taller than the screen, whose foot only comes into view
 *  at the very end of the page. Stacked under the workbench it is not capped.
 *
 *  `--rail-top` is where it sticks: under the top bar while that is sticky (page
 *  column ≥1260 px, see Workbench), near the top of the window once the bar
 *  scrolls away. The cap is derived from the same variable. */
export function RailFrame({ children }: { children: React.ReactNode }) {
  return (
    <div className="sticky top-[var(--rail-top)] flex flex-col gap-3 [--rail-top:1rem] [@container(min-width:1260px)]:[--rail-top:5rem] min-[1080px]:max-h-[calc(100vh-var(--rail-top)-1rem)]">
      {children}
    </div>
  );
}
